export default __webpack_public_path__ + "static/media/photo--lg--robleh.ba8724c0.jpg";